let updater;

document.addEventListener('DOMContentLoaded', updateCounter);
document.addEventListener('resize', updateCounter);
document.addEventListener('scroll', updateCounter);

function isElementInViewport(el) {
    let rect = el.getBoundingClientRect();

    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

function updateCounter() {
    let counters = document.querySelectorAll('.counter__value');
    let interval = 10;

    if (counters.length > 0) {
        if (isElementInViewport(counters[0])) {
            let min = parseInt(counters[0].dataset.min);
            let current = parseInt(counters[0].dataset.current);

            if (current <= min) {
                updater = setInterval(update, interval);
            }
        }
    }

    function update() {
        let finished = true;
        counters.forEach(function (counter) {
            let min = parseInt(counter.dataset.min);
            let max = parseInt(counter.dataset.max);
            let current = parseInt(counter.dataset.current);
            let speed = parseInt(counter.dataset.speed);

            let change;

            if (current < max) {
                change = Math.ceil((max - min) / (speed / interval));
                counter.dataset.current = current + change;
                finished = false;
            } else {
                next = max;
            }
            counter.innerHTML = (counter.dataset.current > max) ? max : counter.dataset.current
        });

        if (finished) {
            clearInterval(updater);
        }
    }
}


